// extracted by mini-css-extract-plugin
export var deleteModal = "_iy-0";